import request from './request.js';
import Servers from '@config'

export default {
  // 订单价格
  fetchOrderPrice: request.get(Servers.oss + '/mall/order/price'),

  // 产品服务
  fetchProductService: request.get(Servers.oss + '/mall/product/service'),

  // 推荐码
  fetchRecommenCode: request.get(Servers.oss + '/mall/client/invite-code'),

  // 提交订单
  saveOrder: request.post(Servers.oss + '/mall/order/add'),

  // 已有发票信息
  fetchNewestInvoice: request.get(Servers.oss + '/mall/invoice/newest'),

  //Google CID列表
  fetchGoogleCidList: request.get(Servers.oss + '/mall/product/cid-list'),

  // 商城 iframe 跳转地址
  fetchQuotationRedirectUrl: request.get(Servers.oss + '/mall/quotation-v2/redirect-url')
}